module.exports = "/img/d5ead73bb014a5965e993da2f9716435.svg";